module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32-e6fa244e7f07179e674119bbdec58769.png";